<template>
	<div class="data-center">
		<ul class="data-list-ul">
			<li v-for="(item,i) in data.data" :key="i" >
				<span class="data-list-title" @click="openUrl(item.url)">{{item.title}}</span>
				<span class="data-list-date">{{item.cdate}}</span>
			</li>
		</ul>
		<div style="text-align: center;">
			<Page @on-change="pageChange" :total="data.total" size="small" :current="query.page" :page-size="query.limit" show-total show-elevator />
		</div>
  		
	</div>

</template>

<script>
	import {queryPageByType} from '@/api/presentation'
	
	export default {
		name: 'textlist',
		data() {
			return {
				query:{
					page:1,
					limit:8
				},
				data:{
					total:0,
					data:[],
				}
			};
			
		},
		created:function(){
			this.queryPageByType();
		},
		props: ["type"],
		methods:{
			queryPageByType:function(){
				this.query.type = this.type;
				
				queryPageByType(this.query).then(r => {
					this.data = r.data;
				});
				
			},
			pageChange:function(page){
				this.query.page = page;
				this.queryPageByType();
			},
			openUrl:function(url){
				window.open(url);
			}
			
		}
	}
</script>

<style scoped lang="scss">
	.data-center {
		border: 1px solid #dcdee2;
		border-top: 0;
		border-color: #dcdee2;
		padding-bottom: 10px;
	}
	
	.data-list-ul {
		padding-left: 30px;
		padding-top: 15px;
		min-height: 287px;
	}
	.data-list-ul li {
		height: 34px;
		font-size: 14px;
	}
	.data-list-title{
		cursor: pointer;
	}
	.data-list-date{
		float: right;
		margin-right: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/view/index/data/textlist.vue